import axios from 'axios';

const checkAuth = () => {
    return axios.get(`${process.env.REACT_APP_TAPI_API}/auth`)
}

export {
    checkAuth,
}
